import React, {Component} from 'react';
import {connect} from 'react-redux';
import TeamChecking from "./team-checking";
import TeamExposure from "./team-exposure";
import TeamLineGroups from "./team-line-groups";
import TeamPPLines from "./team-pp-lines";

class StackTeams extends Component {
    render() {
        const {stacking, stackNumber} = this.props;
        const teams = stacking.getActiveTeamsByStackNumber(stackNumber);

        return (
            <>
                {Object.keys(teams).map(team => (
                    <div key={team} className="stack-box">
                        <TeamChecking team={team} stackNumber={stackNumber}/>
                        <div className="min-max-group">
                            <div className="percent-in">
                            <TeamExposure
                                team={team}
                                exposureType="min"
                                stackNumber={stackNumber}/>
                                <span className="percent">%</span>
                            </div>
                            <div className="percent-in">
                                <TeamExposure
                                    team={team}
                                    exposureType="max"
                                    stackNumber={stackNumber}/>
                                <span className="percent">%</span>
                            </div>
                        </div>
                        <div className="stack-box-section">
                            <TeamLineGroups team={team} stackNumber={stackNumber}/>
                            <TeamPPLines team={team} stackNumber={stackNumber}/>
                        </div>
                    </div>
                ))}
            </>
        );
    }
}

function mapStatesToProps(state) {
    const {
        nhlLegacyTeamStacking,
    } = state;

    return {
        stacking: nhlLegacyTeamStacking,
    }
}

export default connect(mapStatesToProps)(StackTeams);
